module.exports = __webpack_public_path__ + "img/soms_web_15.61e877e6.png";